<div class="logout-message">
  <sol-message type="warning">
    <sol-message-title>Déconnexion</sol-message-title>
    <sol-message-content
      >Pour vous déconnecter de l'application, vous devez fermer votre navigateur.
    </sol-message-content>
  </sol-message>
</div>
